// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YcOh","title":"Header_title__2aA5v","side":"Header_side__3ilc8"};